module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal"
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("activator")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('Convert cart to an order')) + "\n\n    "), _c('div', {
    staticClass: "price ui right floated header blue"
  }, [_vm._v("\n      " + _vm._s(_vm._f("price")(_vm.finalPrice)) + "\n    ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "toolbar"
    },
    slot: "toolbar"
  }, [_c('div', {
    staticClass: "ui left aligned"
  }, [_c('button', {
    staticClass: "ui button green",
    class: {
      loading: _vm.loading
    },
    attrs: {
      "disabled": _vm.createOrderButtonIsDisabled
    },
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Create')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('vertical-table', {
    attrs: {
      "columns": _vm.order_columns,
      "name_class": "four wide",
      "table_class": "ui celled table form"
    }
  }, [_c('div', {
    attrs: {
      "slot": "delivery_address"
    },
    slot: "delivery_address"
  }, [_c('div', {
    staticClass: "inline field"
  }, [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.options.shop_delivery),
      expression: "order.options.shop_delivery"
    }],
    attrs: {
      "id": "delivery_to_shop",
      "type": "checkbox",
      "tabindex": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.order.options.shop_delivery) ? _vm._i(_vm.order.options.shop_delivery, null) > -1 : (_vm.order.options.shop_delivery)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.order.options.shop_delivery,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.order.options, "shop_delivery", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.order.options, "shop_delivery", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.order.options, "shop_delivery", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "cursor",
    attrs: {
      "for": "delivery_to_shop"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('Deliver to shop')) + "\n            ")])])]), _vm._v(" "), (!_vm.order.options.shop_delivery) ? _c('div', {
    staticClass: "four wide column aligned"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.delivery_address),
      expression: "order.delivery_address"
    }],
    staticClass: "ui fluid dropdown selection",
    attrs: {
      "disabled": _vm.order.options.shop_delivery
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.order, "delivery_address", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.currentCustomer.addresses), function(address) {
    return _c('option', {
      key: address.id,
      domProps: {
        "value": address
      }
    }, [_vm._v("\n              " + _vm._s(address.alias + ', ' + address.address1 + ', ' + address.phone_mobile) + "\n            ")])
  }), 0), _vm._v(" "), _c('address-modal', [_c('button', {
    staticClass: "ui blue button",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v("\n              " + _vm._s(_vm.$t('Add a new address')) + "\n            ")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    attrs: {
      "slot": "phone_mobile"
    },
    slot: "phone_mobile"
  }, [_c('div', [_c('input-field', {
    attrs: {
      "validate": "required",
      "name": "Phone (Mobile)",
      "input_type": "text"
    },
    model: {
      value: (_vm.order.phone_mobile),
      callback: function($$v) {
        _vm.$set(_vm.order, "phone_mobile", $$v)
      },
      expression: "order.phone_mobile"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._l((_vm.phones), function(phone, index) {
    return [_c('span', {
      key: 'phone_select_' + index,
      staticClass: "ui label",
      class: {
        green: phone == _vm.order.phone_mobile
      },
      on: {
        "click": function($event) {
          _vm.order.phone_mobile = phone
        }
      }
    }, [_vm._v(_vm._s(phone))])]
  })], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "reductions"
    },
    slot: "reductions"
  }, [_vm._l((_vm.discounts), function(discount, index) {
    return (!discount.generic || discount.isSearchedFromVoucher) ? _c('div', {
      key: index,
      staticClass: "inline field"
    }, [_c('div', {
      staticClass: "ui checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order.reductions[discount.name]),
        expression: "order.reductions[discount.name]"
      }],
      attrs: {
        "id": 'discount_' + discount.name,
        "type": "checkbox",
        "tabindex": "0",
        "disabled": _vm.isFreeShippingVoucher(discount) &&
          _vm.freeShippingVoucherIsDisabled
      },
      domProps: {
        "checked": Array.isArray(_vm.order.reductions[discount.name]) ? _vm._i(_vm.order.reductions[discount.name], null) > -1 : (_vm.order.reductions[discount.name])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.order.reductions[discount.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.order.reductions, discount.name, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.order.reductions, discount.name, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.order.reductions, discount.name, $$c)
          }
        }
      }
    }), _vm._v(" "), [_c('label', {
      staticClass: "cursor",
      attrs: {
        "for": 'discount_' + discount.name
      }
    }, [_vm._v("\n                " + _vm._s(discount.label) + "\n                " + _vm._s(_vm.isFreeShippingVoucher(discount) ?
      _vm.freeShippingVoucherDisabledMessage :
      '') + "\n                ")])]], 2)]) : _vm._e()
  }), _vm._v(" "), (_vm.currentCustomer.group_reduction > 0) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.$t('This user is a privilieged member of group ')) + "\n\n          "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.currentCustomer.group_name))]), _vm._v("\n          , " + _vm._s(_vm.$t('having a reduction of ')) + "\n\n          "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.currentCustomer.group_reduction) + "%")]), _vm._v("\n          !\n        ")]) : _vm._e()], 2), _vm._v(" "), _c('input-field', {
    attrs: {
      "slot": "discount",
      "max": _vm.cartAmount,
      "validate": "decimal",
      "name": "Discount",
      "size": "eight wide",
      "placeholder": "",
      "input_type": "number"
    },
    slot: "discount",
    model: {
      value: (_vm.order.discount),
      callback: function($$v) {
        _vm.$set(_vm.order, "discount", $$v)
      },
      expression: "order.discount"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "voucher"
    },
    slot: "voucher"
  }, [_c('div', [_c('input-field', {
    attrs: {
      "icon": _vm.getvoucherIcons(),
      "class-names": "ui fluid icon input",
      "placeholder": ""
    },
    on: {
      "input": _vm.voucherCheck
    },
    model: {
      value: (_vm.order.voucher),
      callback: function($$v) {
        _vm.$set(_vm.order, "voucher", $$v)
      },
      expression: "order.voucher"
    }
  }), _vm._v(" "), (_vm.voucher) ? _c('span', [_vm._v(_vm._s(_vm.voucher.label))]) : _vm._e(), _vm._v(" "), (_vm.voucherError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.voucherError))]) : _vm._e()], 1)]), _vm._v(" "), _c('input-field', {
    attrs: {
      "slot": "comment",
      "rows": 2,
      "name": "Comment",
      "size": "eight wide",
      "placeholder": "",
      "input_type": "textarea"
    },
    slot: "comment",
    model: {
      value: (_vm.order.comment),
      callback: function($$v) {
        _vm.$set(_vm.order, "comment", $$v)
      },
      expression: "order.comment"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "total-price",
    attrs: {
      "slot": "total_price"
    },
    slot: "total_price"
  }, [_c('span', {
    staticClass: "price-item product-price"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.cartAmount))]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.$t('Product price')))])]), _vm._v(" "), (_vm.groupUserReduction) ? _c('span', {
    staticClass: "price-item group-user-reduction"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.groupUserReduction))]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.$t('Group user reduction')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.vouchersByPercent) ? _c('span', {
    staticClass: "price-item vouchers-by-percent"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.vouchersByPercent))]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.$t('Vouchers by percent')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.vouchersByAmount) ? _c('span', {
    staticClass: "price-item vouchers-by-amount"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.vouchersByAmount))]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v(_vm._s(_vm.$t('Vouchers by amount')) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.priceAfterReduction != _vm.cartAmount) ? _c('span', {
    staticClass: "price-item price-after-reduction"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v("=" + _vm._s(_vm.priceAfterReduction))]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Price after reduction')) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "price-item delivery-price"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v("+" + _vm._s(_vm.deliveryPrice))]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Delivery price')) + "\n          ")])]), _vm._v(" "), _c('span', {
    staticClass: "price-item final-price"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v("=" + _vm._s(_vm.finalPrice) + " €")]), _vm._v(" "), _c('span', {
    staticClass: "tooltip"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Final price')) + "\n          ")])])])], 1)], 1), _vm._v(" "), _c('popup-modal', {
    attrs: {
      "cancel_text": null,
      "index": _vm.order_confirmed,
      "icon": "checkmark",
      "confirm_text": "ok",
      "confirm_class": "ui positive right labeled icon button",
      "text": "Thank you for your order !"
    },
    on: {
      "delete": function($event) {
        return _vm.closeConfirmation(true)
      }
    }
  }), _vm._v(" "), _c('popup-modal', {
    attrs: {
      "cancel_text": null,
      "text": 'An error occured during your order.<br/>' + _vm.error_message,
      "index": _vm.error_order,
      "icon": "checkmark",
      "confirm_text": "Ok, I understand",
      "confirm_class": "ui positive right labeled icon button"
    },
    on: {
      "delete": function($event) {
        return _vm.closeConfirmation(false)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-436a8afa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/OrderModal.vue
// module id = 495
// module chunks = 1